import { imageUrl } from "@/lib/api";
import { useGallery } from "@/hooks/useGallery";

const FAQS = [
  {
    q: "Bagaimana cara pembayaran setelah saya checkout?",
    a: "Pembayaran menggunakan transfer bank manual. Setelah mengisi data checkout, nomor rekening bank (BCA, Mandiri, BRI) akan ditampilkan langsung di layar Anda. Lakukan transfer sesuai total nominal dan konfirmasi bukti transfer.",
  },
  {
    q: "Apakah bisa kirim ke luar kota atau seluruh nusantara?",
    a: "Ya, Puspita Florist melayani pengiriman ke seluruh nusantara. Untuk bunga segar, kami menggunakan kemasan water-tube khusus; untuk bunga kering dan hampers dikirim dengan proteksi ekstra.",
  },
  {
    q: "Apakah bisa menyertakan kartu ucapan khusus?",
    a: "Tentu. Anda dapat menuliskan pesan kartu ucapan pada kolom catatan saat proses checkout tanpa biaya tambahan.",
  },
];

export function Gallery() {
  const { items } = useGallery();
  if (items.length === 0) return null;
  return (
    <section id="galeri" className="py-20 bg-[#FBF9F5] border-b border-[#E8E2D5]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="mb-12">
          <span className="text-xs uppercase tracking-widest text-[#5F755E] font-semibold">
            Galeri Puspita
          </span>
          <h2 className="font-serif-display text-3xl font-normal text-[#1E2B1D] mt-1">
            Karya Tangan Florist Kami
          </h2>
          <p className="text-xs text-[#6B7C66] mt-2 max-w-lg">
            Dokumentasi hasil karya rangkaian bunga asli yang telah dikirim ke pelanggan setia di
            berbagai kota.
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {items.map((g, i) => (
            <div
              key={g.id}
              data-testid={`gallery-${i + 1}`}
              className="aspect-[3/4] rounded-2xl relative overflow-hidden"
            >
              <img
                src={imageUrl(g.image_url)}
                alt={g.tag}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
              <span className="absolute bottom-4 left-4 text-[11px] font-semibold text-[#1E2B1D] bg-[#FBF9F5]/90 px-2.5 py-1 rounded-md backdrop-blur-sm">
                {g.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function Services() {
  const { event_image_url } = useGallery();
  return (
    <section id="layanan" className="py-20 bg-[#F4EFE6] border-b border-[#E8E2D5]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-5">
            <span className="text-xs uppercase tracking-widest text-[#5F755E] font-semibold">
              Layanan Acara
            </span>
            <h2 className="font-serif-display text-3xl font-normal text-[#1E2B1D] mt-2 mb-4 leading-tight">
              Dekorasi Acara & Pernikahan
            </h2>
            <p className="text-xs sm:text-sm text-[#5E6D5B] leading-relaxed mb-6">
              Kami menangani dekorasi bunga menyeluruh untuk pernikahan, peresmian gedung, acara
              korporat, hingga duka cita dengan dedikasi penuh dan pengiriman tepat waktu.
            </p>
            <ul className="space-y-3 text-xs text-[#354634]">
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-[#3D5A40]"></span>
                Konsultasi tema warna & jenis bunga sesuai venue
              </li>
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-[#3D5A40]"></span>
                Pengiriman dan penataan langsung oleh tim perangkai
              </li>
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-[#3D5A40]"></span>
                Tersedia opsi bunga segar maupun preserved tahan lama
              </li>
            </ul>
          </div>
          <div className="lg:col-span-7">
            <div className="aspect-[16/10] rounded-3xl relative overflow-hidden">
              {event_image_url && (
                <img
                  src={imageUrl(event_image_url)}
                  alt="Dekorasi bunga acara karya Puspita Florist"
                  loading="lazy"
                  data-testid="event-image"
                  className="absolute inset-0 w-full h-full object-cover object-[center_60%]"
                />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-[#141F14]/70 via-transparent to-transparent"></div>
              <div className="absolute top-8 left-8 bg-[#1E2B1D]/70 p-4 rounded-xl max-w-xs backdrop-blur-sm border border-white/10">
                <span className="text-[10px] uppercase tracking-widest text-[#B3CDB1] block mb-1">
                  Portofolio Acara
                </span>
                <span className="text-sm font-serif-display text-[#FAF7EE]">
                  Lebih dari ratusan perayaan terhias indah di berbagai kota nusantara.
                </span>
              </div>
              <div className="absolute bottom-8 right-8">
                <a
                  href="#katalog"
                  data-testid="services-cta-btn"
                  className="inline-flex items-center px-4 py-2 rounded-full bg-[#FAF7EE] text-[#1E2B1D] text-xs font-bold hover:bg-[#DCE7DA] transition-colors"
                >
                  Pesan Bunga Sekarang
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function HowItWorks() {
  const steps = [
    {
      n: "A",
      title: "Pilih & Masuk Keranjang",
      desc: "Pilih rangkaian bunga pada katalog, tentukan jumlah, dan masukkan ke keranjang belanja Anda.",
    },
    {
      n: "B",
      title: "Isi Data & Checkout",
      desc: "Lengkapi nama penerima, alamat pengiriman di nusantara, dan pesan kartu ucapan saat checkout.",
    },
    {
      n: "C",
      title: "Transfer Bank Manual",
      desc: "Nomor rekening bank ditampilkan setelah checkout. Lakukan transfer manual dan unggah bukti bayar.",
    },
  ];
  return (
    <section id="cara-pesan" className="py-20 bg-[#FBF9F5] border-b border-[#E8E2D5]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center max-w-md mx-auto mb-14">
          <span className="text-xs uppercase tracking-widest text-[#5F755E] font-semibold">
            Alur Pemesanan Mudah
          </span>
          <h2 className="font-serif-display text-3xl font-normal text-[#1E2B1D] mt-2">
            Cara Pesan & Bayar
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          {steps.map((s) => (
            <div
              key={s.n}
              data-testid={`step-${s.n}`}
              className="bg-[#F4EFE6] rounded-2xl p-6 border border-[#E8E2D5] flex flex-col items-start"
            >
              <div className="w-10 h-10 rounded-xl bg-[#3D5A40] text-[#FAF7EE] flex items-center justify-center font-bold text-sm mb-4">
                {s.n}
              </div>
              <h3 className="font-serif-display text-base font-bold text-[#1E2B1D] mb-1.5">
                {s.title}
              </h3>
              <p className="text-xs text-[#5E6D5B] leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function Faq() {
  return (
    <section id="faq" className="py-20 bg-[#FBF9F5] border-b border-[#E8E2D5]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12">
          <span className="text-xs uppercase tracking-widest text-[#5F755E] font-semibold">
            Informasi Praktis
          </span>
          <h2 className="font-serif-display text-3xl font-normal text-[#1E2B1D] mt-2">
            Pertanyaan yang Sering Diajukan
          </h2>
        </div>
        <div className="space-y-4">
          {FAQS.map((f, i) => (
            <div
              key={i}
              data-testid={`faq-${i + 1}`}
              className="bg-[#F4EFE6] rounded-2xl p-5 border border-[#E8E2D5]"
            >
              <h3 className="font-serif-display text-base font-bold text-[#1E2B1D]">{f.q}</h3>
              <p className="text-xs text-[#5E6D5B] mt-2 leading-relaxed">{f.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
